export const LOADING_LEAVEREQUEST = "LOADING_LEAVEREQUEST";
export const GET_LEAVEREQUEST_LIST = "GET_LEAVEREQUEST_LIST";
//export const GET_LEAVEREQUESTBYID = "GET_LEAVEREQUESTBYID";
//export const REMOVE_LEAVEREQUEST = "REMOVE_LEAVEREQUEST";
export const ADD_LEAVEREQUEST = "ADD_LEAVEREQUEST";
export const UPDATE_LEAVEREQUEST = "UPDATE_LEAVEREQUEST";
export const APPROVAL_LEAVEREQUEST = "APPROVAL_LEAVEREQUEST";
export const GET_LEAVEREQUEST_EMPLOYEE = "GET_LEAVEREQUEST_EMPLOYEE";
export const GET_LEAVEREQUEST_SUBORDINATES = "GET_LEAVEREQUEST_SUBORDINATES";